import React, { useState, useEffect } from 'react';
import { PaymentRequestButtonElement, useStripe } from '@stripe/react-stripe-js';
import styles from './Checkout.module.scss'

const Stripe = ({ cart, setValue, setShowShipping, usStates, setOrderErrors, handleSubmit, onSubmit, unregister, register, skipShipping }) => {
  const stripe = useStripe();
  const [paymentRequest, setPaymentRequest] = useState(null);

  const setShippingInfo = (ev) => {
    setValue("payment_method", "stripe");
    setShowShipping(true);

    // For appointment-only purchases (e.g. senior portrait sessions) there
    // is no physical product to ship, so the Payment Request Button doesn't
    // ask for a shipping address — bail before the shippingAddress read.
    if (skipShipping || !ev.shippingAddress) return;

    const state = usStates.find(s => s.value === ev.shippingAddress.region);
    setValue('shipping_address', ev.shippingAddress.addressLine[0])
    setValue('shipping_address2', ev.shippingAddress.addressLine[1])
    setValue('shipping_state', state)
    setValue('shipping_city', ev.shippingAddress.city)
    setValue('shipping_zip', ev.shippingAddress.postalCode)
  }

  // JS has an issue with certain float numbers
  const shippingInCents = (cart) => {
    if (!cart) return 1;
    if (!cart.shipping) return 1;

    const factor = 100;
    const b = cart.shipping.toString().split('.');

    if (b.length === 1) return cart.shipping*100;

    return b[0]*factor+b[1]*(factor/(Math.pow(10,b[1].length)));
  }

  useEffect(() => {
    if (stripe) {
      const pr = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Shoob Photography Purchase Total',
          amount: cart && parseInt(cart.apiTotal.toFixed(2)*100) || 1,
        },
        requestPayerName: true,
        requestPayerEmail: true,
        // Senior portrait sessions are appointment-only — no shipping. For
        // other carts, ask Apple Pay / Google Pay for the shipping address.
        requestShipping: !skipShipping,
        ...(skipShipping ? {} : {
          shippingOptions: [
            {
              id: 'shipping',
              label: `Shipping - $${cart && cart.shipping.toFixed(2) || 0}`,
              detail: '',
              amount: shippingInCents(cart) || 1,
            },
          ],
        })
      });

      // Check the availability of the Payment Request API.
      pr.canMakePayment().then(result => {
        if (result) {
          setPaymentRequest(pr);
        }
      });

      pr.on('paymentmethod', async (e) => {
        const { client_secret, error } = await fetch(
          `/api/v1/carts/${cart.id}/create_payment_intent`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              paymentMethodType: 'card',
              currency: 'usd',
            }),
          }
        ).then((response) => response.json())

        if (error) {
          setOrderErrors([e.message || 'There was an error processing your payment. Please try again or use another payment method.'])
          e.complete('fail');
          return;
        }

        e.complete('success');

        setShippingInfo(e);
        window.stripeOrder = e;
        window.stripeKey = client_secret;
      });
    }
  }, [stripe]);

  if (paymentRequest) {
    return (
      <div className={styles.radioGroup}>
        <label className={styles.paymentLabel}>
          <input
            {...register("payment_method", { required: true })}
            type="radio"
            onChange={() => unregister(
              ["name_on_card", "card_number", "card_expires_on", "card_verification",
                "address", "address2", "city", "state", "zip_code", "payment_method"])}
            value="stripe" />
            <span>
              <PaymentRequestButtonElement options={{paymentRequest}} />
            </span>
        </label>
      </div>
    );
  }

  return <div />;
}

export default Stripe;
